import React from 'react';

const AddItems = () => {
    return (
        <div>
            <h1>I am Add Items </h1>
        </div>
    );
};

export default AddItems;